export default __webpack_public_path__ + "static/media/Consulting-Dental-Specialist.54577ee7.png";